module.exports = __webpack_public_path__ + "static/media/shine-or-go-crazy.e39602e2.md";